document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('[role="tab"]');
    const tabPanels = document.querySelectorAll('[role="tabpanel"]');

    // Hide all tab panels initially
    tabPanels.forEach(panel => panel.hidden = true);

    tabs.forEach(tab => {
        // On hover, change the content of the corresponding tab panel
        tab.addEventListener('mouseenter', function() {
            // Hide all tab panels
            tabPanels.forEach(panel => panel.hidden = true);

            // Show the relevant panel
            const tabPanelId = tab.getAttribute('aria-controls');
            document.getElementById(tabPanelId).hidden = false; // Show the relevant panel
        });
    });
});
